/* eslint-disable import/no-anonymous-default-export */
import apiClient from "../redux/ApiClient";

export default {
  // withdrawals
  fetchWithdrawals(rowsPerPage, page) {
    return apiClient.get(`/withdrawals/list?rows=${rowsPerPage}&page=${page}`);
  },
  fetchClientTransactions(rowsPerPage, page, clientId, type) {
    return apiClient.get(
      `/transactions/view?rows=${rowsPerPage}&page=${page}&client_id=${clientId}&type=${type}`
    );
  },
  fetchAgentWithdrawals(rowsPerPage, page, agentId) {
    return apiClient.get(
      `/withdrawals/list?rows=${rowsPerPage}&page=${page}&agent_id=${agentId}`
    );
  },

  // withdrawal requests
  fetchWithdrawalRequests(rowsPerPage, page) {
    return apiClient.get(
      `/withdrawals/requests/list?rows=${rowsPerPage}&page=${page}`
    );
  },
};
